import { enableProdMode } from '@angular/core';
import { platformBrowser } from '@angular/platform-browser';
import '@angular/compiler';

import { environment } from '@environments/environment';
import { AppModule } from './app/app.module';

if (environment.production) {
  enableProdMode();
}

// test error white screen (debug login problems after releases).
// throw new Error('White screen, reveal yourself!');

platformBrowser()
  .bootstrapModule(AppModule)
  .catch((err: any) => console.error(err));
